import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario3 from "./Scenario3";
import { alertController } from "@ionic/core";

export default class Scenario3Part4 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;
	
	chapterIds = {
		scenario3_2b_s12: 'CALM - Scenario 3 Start - 2B - Segment 12',
		scenario3_3b_s13: 'CALM - Scenario 3 - 3B - Segment 13'
	}

	constructor(scenario: Scenario3, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario3/calm-scenario3-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario3.parts.level3Part4.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();
		context.scenario.updateObjective('');
	}

	private segment1Step1MirandaApproaches() { 
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.segment1Step2Dialogue();
	}

	private segment1Step2Dialogue() { 
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.dialog(
			'CN-C08-L2-050b',
			[{
				text: 'First, go get the blood from the lab. We can deal with the verification after.',
				feedback: 'Before RN Miranda gets the blood from the lab, it is important that she already has another RN ready to verify the patient and blood identifications.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'Okay, go ahead and find a second RN to help you verify and monitor.',				
				scoreType: ScoreType.Best,
				isCorrect: true
			}, {
				text: 'I\'ll verify for you you and help monitor the patient.',
				feedback:'While you could help Miranda get started, monitoring a patient during a transfusion will take time. You have other duties.',
				scoreType: ScoreType.Worst,
				isCorrect: false
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () => 
				context.segment2Step1MirandaDeparts(), 
				context.partIndx);
				
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment2Step1MirandaDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario3_2b_s12, () => {
			this.onDone()
		});
		context.scenario.updateObjective('');
	}

	private segment2Step2HeatherReturns() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario3_3b_s13, () => {
			this.onDone();
		});
		context.scenario.updateObjective('');
	}
}